/**
 * `/admin/support-topics` — la rotta storica degli argomenti di assistenza, che dal 11-09-2026 è la
 * scheda «Argomenti» dell'hub `/support`. Rimanda lì: la rotta resta per i segnalibri e per la
 * documentazione (`BE-RESPONSE-TO-FE-ASSISTENZA-v1` §5 la cita).
 */
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/support-topics')({
  component: () => <Navigate to="/support" hash="argomenti" replace />,
});
